// extracted by mini-css-extract-plugin
module.exports = {"summary":"FilterSummary_summary__iIicw","summary_disabled":"FilterSummary_summary_disabled__t0fsX","type":"FilterSummary_type___Qax8","value":"FilterSummary_value__v8roT"};